import { API, Product } from "@thenounproject/lingo-core";
import { createQueryAction } from "@actions/actionCreators";

type Args = {
  spaceId: number;
  status?: string;
  productTypeUuid?: string;
  page?: number;
  limit?: number;
  sort?: string;
};

export type ProductsResult = {
  products: Product[];
  total: number;
};

type NormalizedResult = {
  products: string[];
  total: number;
};

const [useProducts, fetchProducts] = createQueryAction<Args, ProductsResult, NormalizedResult>(
  {
    entity: "products",
    action: "fetchProducts",
    condition: ({ args }) => Boolean(args.spaceId),
    denormalize: {
      entity: null,
      products: { entity: "products", productType: "productTypes", previewAsset: "assets" },
    },
    pagingKey: "products",
  },
  async ({ args }) => {
    const res = await API.call<{ products: string[]; total: number }>({
      endpoint: `spaces/${args.spaceId}/products`,
      method: "GET",
      query: {
        status: args.status,
        product_type_uuid: args.productTypeUuid,
        page: args.page,
        limit: args.limit,
        sort: args.sort,
      },
    });
    return res;
  }
);

export default useProducts;
export { fetchProducts };
